<template>
  <ul>
    <li v-for="(item, index) in options" :key="index">
      <label>
        <input
          type="checkbox"
          v-model="model"
          :value="item"
          :checked="options.includes(item) ? true : false"
        />
        <span>{{ item }}</span>
      </label>
    </li>
  </ul>
  <!--p class="debug">model = {{ model }}</p>
    <p class="debug">options = {{ options }}</p-->
</template>

<script setup lang="ts">
const props = defineProps({
  options: { type: Array<any>, required: true } //this should just be plain string arrays?
})

const model = defineModel<any>('checked')
</script>

<style lang="css" scoped>
label {
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  padding-bottom: 0.5rem;
  padding-top: 0.5rem;
  padding-left: 0;
  padding-right: 1rem;
}

ul {
  list-style-type: none;
  margin: 0;
  padding-bottom: 0.5rem;
  padding-top: 0.5rem;
  padding-left: 0;
  padding-right: 1rem;
  display: flex;
  flex-flow: column wrap;
  justify-content: flex-start;
  height: 100%;
  /*max-height: 24rem;*/
  /* margin-bottom: 1rem;*/
}
/*
div{
    display: flex;
    flex-flow: column wrap;
    max-height: 16rem;
}

input{
    height: 1rem;
    width: 1rem;
}
*/
span{
    display: block;
    font-size: 0.825rem;
    padding-left: 0.25rem;
}

</style>
